export const ENV = {
  VERSION: "1.0",
  API_VERSION: "2.0",
  PUBLIC_STRIPE_KEY: "pk_live_jPIp7VtQcSPLJIBYoxIQjCwv00YbiAeSYq",
  ENDPOINT: "https://api.youbumerang.com/api/v3",
  CURRENT_ENV: "production",
  CRISP_ID: "ed9a8769-ce9b-402c-849d-02d52da57337",
};
